/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Common_Searchmincharshint3Inputs */

const en_common_searchmincharshint3 = /** @type {(inputs: Common_Searchmincharshint3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Type at least ${i?.count} characters to search`)
};

/**
* | output |
* | --- |
* | "Type at least {count} characters to search" |
*
* @param {Common_Searchmincharshint3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_searchmincharshint3 = /** @type {((inputs: Common_Searchmincharshint3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Searchmincharshint3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_searchmincharshint3(inputs)
});
export { common_searchmincharshint3 as "common_searchMinCharsHint" }